var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"loading-box"},[_c('a-spin',{attrs:{"tip":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }